// @flow
/** @jsx jsx */
import * as React from 'react';
import { keyframes, jsx } from '@emotion/core';

import Backdrop from './Backdrop';
import colors from '../config/colors';

const bounceSmall = keyframes`
  33% {
    transform: translateY(4px);
  }
  66% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
`;

const bounceBig = keyframes`
  33% {
    transform: translateY(10px);
  }
  66% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`;

const SyncLoader = ({
  loading,
  size = 'big',
  className,
  itemClassName,
  message,
}: {
  loading: boolean,
  size?: 'big' | 'small',
  className?: string,
  itemClassName?: string,
  message?: string,
}) => {
  if (!loading) return null;
  const items = [1, 2, 3];

  return (
    <div
      css={[
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
        className,
      ]}
    >
      <div>
        {items.map(i => (
          <div
            css={[
              {
                backgroundColor: colors.emerald,
                width: `${size === 'big' ? 15 : 5}px`,
                height: `${size === 'big' ? 15 : 5}px`,
                borderRadius: '100%',
                margin: `${size === 'big' ? 5 : 2}px`,
                display: 'inline-block',
                animationFillMode: 'both',
                animation: `${size === 'big' ? bounceBig : bounceSmall} 0.6s
                  ${i * 0.07 - 0.07 * items.length}s infinite ease-in-out`,
              },
              itemClassName,
            ]}
            key={i}
          />
        ))}
      </div>
      {message && (
        <div
          css={{
            textAlign: 'center',
            background: 'rgba(20, 156, 130, 0.6)',
            color: 'white',
            padding: '5px',
            margin: '5px 0',
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

SyncLoader.defaultProps = {
  loading: true,
};

type Props = {
  blocking: boolean,
  size?: 'big' | 'small',
};

const Loading = (props: Props) => (
  <React.Fragment>
    {props.blocking ? (
      <Backdrop>
        <SyncLoader {...props} />
      </Backdrop>
    ) : (
      <SyncLoader {...props} />
    )}
  </React.Fragment>
);

Loading.defaultProps = {
  blocking: true,
};

export default Loading;
